// extracted by mini-css-extract-plugin
export var container = "_5e-0";
export var disabled = "_5e-4";
export var fullWidth = "_5e-3";
export var lined = "_5e-1";
export var selected = "_5e-5";
export var tab = "_5e-2";